import { render } from "./11.md?vue&type=template&id=4d2f378b"
const script = {}

import exportComponent from "C:\\MyFile\\codeVue\\xb-notes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__